import { Dropdown, DropdownListItem, FInter } from "@brg/ui";
import { LayoutConst } from "core";
import React, { FC, ReactNode } from "react";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import styled, { useTheme } from 'styled-components';
import {useTranslation} from "react-i18next";
import { AppTester } from "supporting";
import { useSelector } from "react-redux";
import { ThemeSlideColorSelector } from "shared/reducers/ThemeSlideColorSlice";

export interface LinksItems {
    action: () => void;
    isLinks: boolean;
    element: ReactNode;
  }

const DropdownText = styled(FInter.SmallTextBoldMagic)<{ isActive?: boolean, color?: string, hover?: string }>`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${p => p?.isActive ? (p?.color || p.theme.icon.active) : p.theme.icon.hoverSpecialActive};
`;

export const DropdownTabs: FC<{
    items: Record<string, ReactNode | string | LinksItems>;
    activeTabKey: string;
    onChange: (indexKey: string) => void;
    whiteTheme?: boolean;
    onTeamClick?: () => void;
    hasEmployees?: boolean;
    mobileShrink?: boolean
}> = ({
    items,
    onChange,
    activeTabKey,
    whiteTheme,
    hasEmployees,
    onTeamClick,
    mobileShrink
}) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const importantItemColor = useSelector(ThemeSlideColorSelector)?.slideColor;

    return (
        <Dropdown
        offsetY={12}
        // offsetX={is744BP ? 0 : -2}
        dark={whiteTheme}
        hideArrow
        orientation={'left'}
        target={
          <ArrowTopIconWithText 
          //@ts-ignore
            text={items[activeTabKey]?.toLowerCase()} 
            shrimpIcon
            mobileShrink={mobileShrink}
            importantColor={importantItemColor?.color}
            fill={'#909090'} 
          />
        }
      >
        {Object.keys(items)?.map((key) => {
          return (
            <div key={key} onClick={() => {
            //   if (key === activeTabKey) return false;
            //   //@ts-ignore
            //   if (isLink) return tabItems[key]?.action()
              onChange(key);
            }}>
              <DropdownListItem
                justify='space-between'
                isActive={key === activeTabKey}
              >
                <DropdownText isActive={key === activeTabKey} {...importantItemColor}>
                  {/*@ts-ignore*/}
                  {items[key]?.toLowerCase()}
                </DropdownText>
                <ApprovedIcon fill={theme.icon.active} display={key === activeTabKey}/>
              </DropdownListItem>
            </div>
          )
        }
        )}
            {hasEmployees && <div key={'team'} onClick={() => onTeamClick && onTeamClick()}>
                <DropdownListItem
                    justify='flex-start'
                    isActive={false}
                >
                    <DropdownText isActive={false} style={{marginRight: '4px'}}>
                        {t('nav.team')}
                    </DropdownText>
                    <svg
                        width='16'
                        height='20'
                        viewBox='0 0 16 14'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            fill={theme.icon.hoverSpecialActive}
                            d='M12 10.7149H10.3329L10.3431 6.86984L5.21474 12L4 10.786L9.12833 5.65587H5.27573L5.2859 4H12V10.7149Z'
                        />
                    </svg>
                </DropdownListItem>
            </div>}
      </Dropdown>
    )
}import { Dropdown, DropdownListItem, FInter } from "@brg/ui";
import { LayoutConst } from "core";
import React, { FC, ReactNode } from "react";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import styled, { useTheme } from 'styled-components';
import {useTranslation} from "react-i18next";
import { AppTester } from "supporting";
import { useSelector } from "react-redux";
import { ThemeSlideColorSelector } from "shared/reducers/ThemeSlideColorSlice";

export interface LinksItems {
    action: () => void;
    isLinks: boolean;
    element: ReactNode;
  }

const DropdownText = styled(FInter.SmallTextBoldMagic)<{ isActive?: boolean, color?: string, hover?: string }>`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${p => p?.isActive ? (p?.color || p.theme.icon.active) : p.theme.icon.hoverSpecialActive};
`;

export const DropdownTabs: FC<{
    items: Record<string, ReactNode | string | LinksItems>;
    activeTabKey: string;
    onChange: (indexKey: string) => void;
    whiteTheme?: boolean;
    onTeamClick?: () => void;
    hasEmployees?: boolean;
    mobileShrink?: boolean
}> = ({
    items,
    onChange,
    activeTabKey,
    whiteTheme,
    hasEmployees,
    onTeamClick,
    mobileShrink
}) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const importantItemColor = useSelector(ThemeSlideColorSelector)?.slideColor;

    return (
        <Dropdown
        offsetY={12}
        // offsetX={is744BP ? 0 : -2}
        dark={whiteTheme}
        hideArrow
        orientation={'left'}
        target={
          <ArrowTopIconWithText 
          //@ts-ignore
            text={items[activeTabKey]?.toLowerCase()} 
            shrimpIcon
            mobileShrink={mobileShrink}
            importantColor={importantItemColor?.color}
            fill={'#909090'} 
          />
        }
      >
        {Object.keys(items)?.map((key) => {
          return (
            <div key={key} onClick={() => {
            //   if (key === activeTabKey) return false;
            //   //@ts-ignore
            //   if (isLink) return tabItems[key]?.action()
              onChange(key);
            }}>
              <DropdownListItem
                justify='space-between'
                isActive={key === activeTabKey}
              >
                <DropdownText isActive={key === activeTabKey} {...importantItemColor}>
                  {/*@ts-ignore*/}
                  {items[key]?.toLowerCase()}
                </DropdownText>
                <ApprovedIcon fill={theme.icon.active} display={key === activeTabKey}/>
              </DropdownListItem>
            </div>
          )
        }
        )}
            {hasEmployees && <div key={'team'} onClick={() => onTeamClick && onTeamClick()}>
                <DropdownListItem
                    justify='flex-start'
                    isActive={false}
                >
                    <DropdownText isActive={false} style={{marginRight: '4px'}}>
                        {t('nav.team')}
                    </DropdownText>
                    <svg
                        width='16'
                        height='20'
                        viewBox='0 0 16 14'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            fill={theme.icon.hoverSpecialActive}
                            d='M12 10.7149H10.3329L10.3431 6.86984L5.21474 12L4 10.786L9.12833 5.65587H5.27573L5.2859 4H12V10.7149Z'
                        />
                    </svg>
                </DropdownListItem>
            </div>}
      </Dropdown>
    )
}